<template>
  <div class="production-header">
    <div class="header-page mb-3">
      <b-button variant="link" class="btn-back p-0" @click="$emit('back')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5M12 19L5 12L12 5" stroke="#007A4A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </b-button>
      <h3 class="page-title m-0">{{ title }}</h3>
    </div>

    <div class="support-text-section mb-4">
      <p class="support-text m-0">
        {{ supportText }}<br />
        {{ historyText }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductionHeader",
  props: {
    title: {
      type: String,
      default: "Gestão de Produção",
    },
    supportText: {
      type: String,
      default: "Acompanhe sua produção e repasses, gere demonstrativos e envie notas fiscais em um só lugar.",
    },
    historyText: {
      type: String,
      default: "Este espaço consolida seus registros atuais e o histórico de períodos anteriores, disponíveis ao final da página.",
    },
  },
};
</script>

<style lang="scss" scoped>
.header-page {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  height: 36px;

  .btn-back {
    background: transparent;
    border: none;
    box-shadow: none;
  }

  .page-title {
    font-size: 28px;
    line-height: 34px;
    color: #3D3F40;
    font-weight: 400;

    @media (max-width: 768px) {
      font-size: 22px;
    }
  }
}

.support-text-section {
  .support-text {
    font-size: 12.8px;
    line-height: 19px;
    color: #393C40;
  }
}
</style>